// api
import request from '@/tool/request'

const c = 'Task/';

// 获取excel导出的token
export function excelToken(query) {
  return request({
    url: c+'excelToken',
    method: 'post',
    data:query
  })
}


// 后台首页
export function index(query) {
  return request({
    url: c+'index',
    method: 'post',
    data:query
  })
}
// 获取站内信未读数量
export function znxNoRead(query) {
  return request({
    url: c+'znxNoRead',
    method: 'post',
    data:query
  })
}
// 获取基础服务费
export function baseCostList(query) {
  return request({
    url: c+'baseCostList',
    method: 'post',
    data:query
  })
}
// 获取平台
export function platformList(query) {
  return request({
    url: c+'platformList',
    method: 'post',
    data:query
  })
}
// 获取国家
export function countryList(query) {
  return request({
    url: c+'countryList',
    method: 'post',
    data:query
  })
}
// 获取增值服务
export function sCostList(query) {
  return request({
    url: c+'sCostList',
    method: 'post',
    data:query
  })
}
// 获取收费标准
export function costList(query) {
  return request({
    url: c+'costList',
    method: 'post',
    data:query
  })
}
// 提交任务
export function taskAdd(query) {
  return request({
    url: c+'taskAdd',
    method: 'post',
    data:query
  })
}
// 任务列表
export function taskList(query) {
  return request({
    url: c+'taskList',
    method: 'post',
    data:query
  })
}
// 任务取消
export function taskCancel(query) {
  return request({
    url: c+'taskCancel',
    method: 'post',
    data:query
  })
}

// 获取平台和国家
export function getPc(query) {
  return request({
    url: c+'getPc',
    method: 'post',
    data:query
  })
}
// 任务模板
export function taskTmpl(query) {
  return request({
    url: c+'taskTmpl',
    method: 'post',
    data:query
  })
}
// 任务模板 - 详情
export function tmplDetails(query) {
  return request({
    url: c+'tmplDetails',
    method: 'post',
    data:query
  })
}
// 任务模板 - 删除
export function tmplDel(query) {
  return request({
    url: c+'tmplDel',
    method: 'post',
    data:query
  })
}

/****************************** 订单汇总 ******************************/
// 列表页的其他数据
export function orderListInit(query) {
  return request({
    url: c+'orderListInit',
    method: 'post',
    data:query
  })
}
// 列表
export function orderList(query) {
  return request({
    url: c+'orderList',
    method: 'post',
    data:query
  })
}
// 发货
export function sendGoods(query) {
  return request({
    url: c+'sendGoods',
    method: 'post',
    data:query
  })
}
// 评语设置
export function pjSet(query) {
  return request({
    url: c+'pjSet',
    method: 'post',
    data:query
  })
}
// 订单投诉
export function orderComplain(query) {
  return request({
    url: c+'orderComplain',
    method: 'post',
    data:query
  })
}
// 列表页的其他数据
export function complainListInit(query) {
  return request({
    url: c+'complainListInit',
    method: 'post',
    data:query
  })
}
// 投诉列表
export function complainList(query) {
  return request({
    url: c+'complainList',
    method: 'post',
    data:query
  })
}

/****************************** 站内信 ******************************/
// 站内信
export function msgList(query) {
  return request({
    url: c+'msgList',
    method: 'post',
    data:query
  })
}
// 站内信 - 已读
export function msgRead(query) {
  return request({
    url: c+'msgRead',
    method: 'post',
    data:query
  })
}
// 店铺 - 添加
export function storeAdd(query) {
  return request({
    url: c+'storeAdd',
    method: 'post',
    data:query
  })
}
// 店铺 - 列表
export function storeList(query) {
  return request({
    url: c+'storeList',
    method: 'post',
    data:query
  })
}
// 获取配置
export function getSysSet(query) {
  return request({
    url: c+'getSysSet',
    method: 'post',
    data:query
  })
}
// 充值
export function recharge(query) {
  return request({
    url: c+'recharge',
    method: 'post',
    data:query
  })
}
// 充值明细
export function rechargeList(query) {
  return request({
    url: c+'rechargeList',
    method: 'post',
    data:query
  })
}
// 资金明细的其他数据
export function brListInit(query) {
  return request({
    url: c+'brListInit',
    method: 'post',
    data:query
  })
}
// 资金明细
export function brList(query) {
  return request({
    url: c+'brList',
    method: 'post',
    data:query
  })
}

/****************************** 退出登录 ******************************/
// 退出登录
export function logout(query) {
  return request({
    url: c+'logout',
    method: 'post',
    data:query
  })
}

/****************************** 基本信息 ******************************/
// 获取基本信息
export function userIndex(query) {
  return request({
    url: c+'userIndex',
    method: 'post',
    data:query
  })
}
// 设置基本信息
export function setUserIndex(query) {
  return request({
    url: c+'setUserIndex',
    method: 'post',
    data:query
  })
}

/****************************** 账户安全 ******************************/
// 修改密码
export function changePwd(query) {
  return request({
    url: c+'changePwd',
    method: 'post',
    data:query
  })
}